<template>
    <div>
        <div class="news-notification__box">
            <v-card>
                <v-row>
                    <v-col cols="16" sm="5" class="news-notification__profileinfo">
                        <v-row>
                            <v-col cols="16" sm="5" class="news-notification__image">
                                <router-link :to="link">
                                    <img :src="avatar" />
                                </router-link>
                            </v-col>
                            <v-col cols="16" sm="11" class="news-notification__author">
                                <h2 class="section-smalltitle">{{ author }}</h2>
                                <p><span class="news-notification__time">{{ created | formatToday }}</span></p>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="16" offset="0" sm="11" class="news-notification__message">
                        <v-card-title>{{ title }}</v-card-title>
                        <v-card-text><slot></slot></v-card-text>
                        <v-card-actions>
                            <div class="news-notification__buttons">
                                <slot name="actions"></slot>
                            </div>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotificationItem',
        props: {
            title: {
                type: String,
                required: true,
            },
            created: {
                type: Object,
                required: true,
            },
            avatar: {
                type: String,
                required: true,
            },
            author: {
                type: String,
                required: true,
            },
            link: {
                type: Object,
                required: true,
            },
        },
    }
</script>
